import type { BrandConfig } from "@callcenterai/brand";

/**
 * Feature 294 — the brand of this kitchen display, chosen at build by
 * VITE_BRAND_ID (see vite.config.ts), which writes only that brand into the
 * bundle as __KDS_BRAND__. Read its fields, never compare its id.
 */
declare const __KDS_BRAND__: BrandConfig;

export const brand: BrandConfig = __KDS_BRAND__;
